import { Component, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";
import { ToastrService } from 'ngx-toastr';

import { ProductTableService } from 'src/service/product.service';

import { Product } from 'src/api/models/product';
import { LicenseType } from 'src/api/models/license-type';
import { LicenseTypeService } from 'src/api/services';


@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  
  public product : Product = {} as Product;
  public editProduct : Product;
  public license : LicenseType = {} as LicenseType;
  public editLicense : LicenseType;

  public remoteData: Observable<any[]>;

  constructor(
    public service: ProductTableService,
    private licenseTypeService: LicenseTypeService,
    private toasterService: ToastrService
    ) { 
    this.remoteData = this.service.remoteData;
  }

  ngOnInit(): void {    
    this.service.get();
  }

  public removeProduct(toDelete) {
    this.service.remove(toDelete);
  }

  public saveRow(product) {
      this.service.update(product as Product).subscribe(
        res => {
          this.toasterService.success('Successfully Updated Product', 'Update Product');
        },
        err => {
          console.error("ERROR: saveRow", err);
          this.toasterService.error('Failed to Update Product: ' + err.error.text, 'Update Product');
        }
      );
  }


  public saveLicenseType(lt: LicenseType){
    //alert(id);
    this.licenseTypeService.LicenseTypeUpdateLicenseTypeById(lt).subscribe(
      res => {
        this.toasterService.success('Successfully Updated License Type', 'Update License Type');
      },
      err => {       
        this.toasterService.error('Failed to Update License Type: ' + err.error.text, 'Update License Type'); 
      }
    );
  }

  public addRow() {
    // post to service then add to table
    this.service.add(this.product).subscribe(
      res => {
        this.cancel();
        this.toasterService.success('Successfully Created Product', 'Create Product');
      },
      err => {
        console.error("ERROR: addRow", err);
        this.toasterService.error('Failed to Create Product: ' + err.error.text, 'Create Product');
      }
    );
  }

  public cancel() {
      //this.dialog.close();
      this.product = {} as Product;
  }

  public addLicense() {
    this.licenseTypeService.LicenseTypeCreateLicenseType({productId: this.editProduct.productId, model: this.license}).subscribe(r => {
      this.editProduct.licenseTypes.push(r);
    }, err => {
      this.toasterService.error(err, "Add License Type");
    });
  }

  selectProduct(product){
    this.editProduct = product;
  }

  removeLicense(license: LicenseType){
    this.licenseTypeService.LicenseTypeDeleteLicenseTypeById(license.licenseTypeId).subscribe(r => {
      var index = this.editProduct.licenseTypes.indexOf(license);
      this.editProduct.licenseTypes.splice(index, 1);
      this.toasterService.success("Success", "License Type Deleted");
    }, err=>{
      this.toasterService.error(err, "License Type Delete");
    });
  }
}
